'use strict';

var Promise = require('bluebird');

function fetch (url) {
  return Promise.resolve($.ajax({
    url: url,
    type: 'GET',
    dataType: 'html',
    cache: true,
    beforeSend: function (jqXHR, settings) {
      jqXHR.url = settings.url;
    }
  }));
}

const cache = {};

function fetchWithCache (url) {
  if (!cache[url]) {
    cache[url] = fetch(url);
  }
  return cache[url];
}

module.exports = fetchWithCache;
